const data = {
  imagebaseurl: 'https://glisselisbeth.github.io/',
  name: 'Glisse Jorge',
  role: [
    {
      name: 'Full Stack Developer'
    },
    {
      name: 'Ingeniera de Sistemas'
    }
  ],
  study: [
    {
      name: 'Universidad San Cristóbal'
    },
    {
      name: 'Laboratoria'
    }
  ],
  linkedinId: 'glisselisbeth',
  skypeid: 'glisse86',
  roleDescription: 'Apasionada por los códigos y la tecnología',
  socialLinks: [
    {
      name: 'facebook',
      url: 'https://www.facebook.com/glisselisbeth/',
      className: 'fa fa-facebook-square'
    },
    {
      name: 'github',
      url: 'http://github.com/glisselisbeth',
      className: 'fa fa-github-square'
    },
    {
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/glissejorge/',
      className: 'fa fa-linkedin-square'
    }
  ],
  aboutme:
    'Una de mis experiencias en el área de desarrollo web y de aplicaciones, es que con cada línea de código, me esfuerzo por hacer de la web y la aplicación un lugar hermoso y con la mejor experiencia del usuario. Trabajar con un equipo multidisciplinario y bajo los enfoques de metodologías ágiles. Siempre estuve interesada en las diferentes tecnologías y los códigos.',
  email: 'glissejorge@gmail.com',
  education: [
    {
      UniversityName: 'Universidad Nacional San Cristóbal de Huamanga',
      specialization: 'Bachiller en Ingeniería de Sistemas',
      YearOfPassing: '2005-2011'
    },
    {
      UniversityName: 'Laboratoria',
      specialization: 'Frontend Developer',
      YearOfPassing: '2017'
    }
  ],
  skillTitle: 'Mis habilidades tecnológicas',
  skillDescription:
    'Activamente en un continuo aprendizaje exponencial y la responsabilidad de hacerlo.',
  skills: [
    {
      skillName: 'HTML5',
      imgName: 'html5'
    },
    {
      skillName: 'CSS',
      imgName: 'css3'
    },
    {
      skillName: 'Javascript',
      imgName: 'JS'
    },
    {
      skillName: 'Firebase',
      imgName: 'firebase'
    },
    {
      skillName: 'Bootstrap',
      imgName: 'bootstrap'
    },
    {
      skillName: 'ReactJS',
      imgName: 'react'
    },
    {
      skillName: 'React Native',
      imgName: 'react-native'
    },
    {
      skillName: 'Typescript',
      imgName: 'ts'
    },
    {
      skillName: 'Python',
      imgName: 'python'
    },
    {
      skillName: 'Git',
      imgName: 'git'
    },
    {
      skillName: 'Github',
      imgName: 'github'
    },
    {
      skillName: 'NodeJS',
      imgName: 'node3'
    }
  ],
  portfolio: [
    {
      num: '01',
      ord: '#01',
      title: 'Landing Sodimac',
      description:
        'Repositorio implementado en Altimea para el desarrollo de Sodimac de Alquiler de herramientas.',
      imgurl: 'images/portfolio/sodimac.png',
      type: 'Web y Mobile',
      link: 'https://github.com/GlisseLisbeth/landing_sodimac_web',
      code: 'https://github.com/GlisseLisbeth/landing_sodimac_web',
      production: false
    },
    {
      num: '02',
      ord: '#02',
      title: 'Github User App',
      description:
        'Un cliente frontend de React que se comunica con la API Github GraphQL y el cliente Apollo.',
      imgurl: 'images/portfolio/github-user_2.png',
      type: 'Mobile',
      link: 'https://github.com/GlisseLisbeth/react-graphql-apollo',
      code: 'https://github.com/GlisseLisbeth/react-graphql-apollo',
      production: false
    },
    {
      num: '03',
      ord: '#03',
      title: 'Task App',
      description: 'Ejemplo implementado cor React y Typescript',
      imgurl: 'images/portfolio/note.png',
      type: 'Mobile',
      link: 'https://glisselisbeth.github.io/react-typescript/',
      code: 'https://github.com/GlisseLisbeth/react-typescript',
      production: true
    },
    {
      num: '04',
      ord: '#04',
      title: 'Laboratoria News',
      description:
        'Caso implementado en equipo, con herramientas como gulp, sass, nodemon, express, firebase y API',
      imgurl: 'images/portfolio/laboratoria_news.png',
      type: 'Web y Mobile',
      link: 'https://laboratoria-news6.herokuapp.com/',
      code: 'https://github.com/GlisseLisbeth/Laboratoria-news-codereview',
      production: true
    },
    {
      num: '05',
      ord: '#05',
      title: 'Yape App',
      description: 'Aplicación Node.js con Docker y express',
      imgurl: 'images/portfolio/yape.png',
      type: 'Mobile',
      link: 'https://stormy-plains-32030.herokuapp.com/',
      code: 'https://github.com/GlisseLisbeth/yape-app-docker/',
      production: true
    },
    {
      num: '06',
      ord: '#06',
      title: 'Pokedex',
      description:
        'Sitio web utilizado Api Official Pokedex con Ajax, Nodejs y Express 5',
      imgurl: 'images/portfolio/pokedex.png',
      type: 'Web y Mobile',
      link: 'https://pokedex-v2.herokuapp.com/',
      code: 'https://github.com/GlisseLisbeth/pokedex-v2',
      production: true
    }
  ]
};

export default data;
